import styled from 'styled-components/macro';
import { Link } from '@yme/components/Link';
import { colorCoreGray100, colorCoreGray600 } from '@yme/tokens/colors';
import { elevationTopLvl4 } from '@yme/tokens/elevations';
import { ADAPTIVE } from '@yme/tokens/screen';
import { transition300ms } from '@yme/tokens/transitions';
import { Z_INDEX } from '@yme/tokens/zindex';
export const StickyBarStyled = styled.div `
  position: fixed;
  padding: 16px 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background-color: ${colorCoreGray100};
  transition: ${transition300ms};

  ${ADAPTIVE.minWidth.desktop} {
    padding: 24px 0px;
  }

  ${({ isStickyBarExpanded }) => !isStickyBarExpanded && `box-shadow: ${elevationTopLvl4};`}
  transform: ${({ isHidden }) => (isHidden ? 'translateY(100%)' : 'translateY(0%)')};
  z-index: ${({ isStickyBarExpanded }) => isStickyBarExpanded ? Z_INDEX.popupLevel3 : Z_INDEX.level3};
  ${({ isStickyBarExpanded }) => isStickyBarExpanded && `border-top: 1px solid ${colorCoreGray600};`}
`;
export const LinkStyled = styled(Link) `
  flex-grow: 1;
  text-decoration: none;
`;
